"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _ms = _interopRequireDefault(require("ms"));
var _rowConfig = _interopRequireDefault(require("../../core/row-config"));
var _formGroup = _interopRequireDefault(require("../../core/form-group"));
var _label = _interopRequireDefault(require("../../core/label"));
var _col = _interopRequireDefault(require("../../core/col"));
var _inputOnBlur = _interopRequireDefault(require("../../core/input-on-blur"));
var _button = _interopRequireDefault(require("../../core/button"));
var _setupClubAccountForm = _interopRequireDefault(require("./setup-club-account-form"));
var _newTreasurerForm = _interopRequireDefault(require("./newTreasurerForm"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _ref = /*#__PURE__*/_react.default.createElement(_label.default, null, "Club Name");
var _ref2 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Status");
var _ref3 = /*#__PURE__*/_react.default.createElement("div", null, "Stripe is setup, ready to take entries");
var _ref4 = /*#__PURE__*/_react.default.createElement("div", null, "Stripe is setup and waiting for stripe verification");
var _ref5 = /*#__PURE__*/_react.default.createElement("p", null, "Stripe is setup, but verification has failed.");
var _ref6 = /*#__PURE__*/_react.default.createElement("p", null, "No code is available to pass to user yet - check Stripe dashboard before sending update request");
var _ref7 = /*#__PURE__*/_react.default.createElement("p", null, "Waiting for initiator");
var _ref8 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Initiator email");
var _ref9 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Initiator name");
var _ref10 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Treasurer email");
var _ref11 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Treasurer name");
class Club extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      addInitiatorOpen: false,
      newTreasurerOpen: false
    });
    _defineProperty(this, "_setValue", (value, field) => {
      this.props.onUpdate({
        id: this.props.club.id,
        field,
        value
      });
    });
    _defineProperty(this, "_onToggleAddInitiator", () => {
      this.setState({
        addInitiatorOpen: !this.state.addInitiatorOpen
      });
    });
    _defineProperty(this, "_onToggleNewTreasurer", () => {
      this.setState({
        newTreasurerOpen: !this.state.newTreasurerOpen
      });
    });
    _defineProperty(this, "_onSubmit", data => {
      return this.props.onSetupAccount({
        id: this.props.club.id,
        ...data
      }).then(() => {
        this.setState({
          addInitiatorOpen: false
        });
      });
    });
    _defineProperty(this, "_onSendInstructionsToTreasurer", () => {
      this.props.onSendInstructionsToTreasurer(this.props.club.id);
    });
  }
  componentDidMount() {
    this._interval = setInterval(() => this.setState({
      update: Date.now()
    }), 500);
  }
  componentWillUnmount() {
    clearInterval(this._interval);
  }
  render() {
    // get time treasurer e-mail last sent in ms since unix epoch
    const treasurerEmailSent = this.props.club.treasurerEmailSent ? new Date(this.props.club.treasurerEmailSent).getTime() : 0;
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h2", null, this.props.club.clubName), /*#__PURE__*/_react.default.createElement(_rowConfig.default, {
      columns: [{
        sm: 4,
        md: 3
      }, {
        sm: 8,
        md: 9
      }]
    }, /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_inputOnBlur.default, {
      type: "text",
      name: "clubName",
      value: this.props.club.clubName,
      onChange: this._setValue,
      required: true
    }))), /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref2, /*#__PURE__*/_react.default.createElement(_col.default, null, this.props.club.hasStripeSetup ? this.props.club.verificationStatus.status === 'verified' ? _ref3 : this.props.club.verificationStatus.status === 'pending' ? _ref4 : /*#__PURE__*/_react.default.createElement("div", null, _ref5, !this.props.club.verificationStatus.details ? null : /*#__PURE__*/_react.default.createElement("p", null, this.props.club.verificationStatus.details), !this.props.club.verificationStatus.detailsCode ? _ref6 : /*#__PURE__*/_react.default.createElement("p", null, "Details Code: ", this.props.club.verificationStatus.detailsCode), !this.props.club.verificationStatus.fieldsNeeded ? null : /*#__PURE__*/_react.default.createElement("p", null, "Missing fields: ", this.props.club.verificationStatus.fieldsNeeded.join('; ')), /*#__PURE__*/_react.default.createElement("p", null, "Email sent to treasurer ", (0, _ms.default)(Math.max(Date.now() - treasurerEmailSent, 0), {
      long: true
    }), " ago."), /*#__PURE__*/_react.default.createElement("div", {
      style: {
        marginBottom: 8
      }
    }, /*#__PURE__*/_react.default.createElement(_button.default, {
      type: "primary",
      disabled: Date.now() - treasurerEmailSent < (0, _ms.default)('15 minutes'),
      onClick: this._onSendInstructionsToTreasurer
    }, "Send Update Request to Treasurer"), /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: this._onToggleNewTreasurer
    }, this.state.newTreasurerOpen ? 'Close New Treasurer' : 'New Treasurer'))) : this.props.club.hasBankDetailsHash ? /*#__PURE__*/_react.default.createElement("div", null, !this.props.club.treasurerEmailSent ? null : /*#__PURE__*/_react.default.createElement("p", null, "Waiting for treasurer to setup. Email sent", ' ', (0, _ms.default)(Math.max(Date.now() - treasurerEmailSent, 0), {
      long: true
    }), " ago."), /*#__PURE__*/_react.default.createElement("div", {
      style: {
        marginBottom: 8
      }
    }, /*#__PURE__*/_react.default.createElement(_button.default, {
      type: "primary",
      disabled: Date.now() - treasurerEmailSent < (0, _ms.default)('15 minutes'),
      onClick: this._onSendInstructionsToTreasurer
    }, "Send Setup Instructions to Treasurer"), /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: this._onToggleAddInitiator
    }, this.state.addInitiatorOpen ? 'Hide Initial Details Form' : 'Reset Initial Details'))) : /*#__PURE__*/_react.default.createElement("div", null, _ref7, /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: this._onToggleAddInitiator
    }, this.state.addInitiatorOpen ? 'Hide Initiator Details' : 'Add Initiator Details')))), /*#__PURE__*/_react.default.createElement(_newTreasurerForm.default, {
      isOpened: this.state.newTreasurerOpen,
      clubID: this.props.club.id,
      onCloseCancel: this._onToggleNewTreasurer
    }), !this.props.club.hasBankDetailsHash || this.state.addInitiatorOpen ? null : /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref8, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement("span", {
      href: 'mailto:' + this.props.club.initiatorEmail
    }, " ", this.props.club.initiatorEmail))), /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref9, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement("span", null, this.props.club.initiatorName))), /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref10, /*#__PURE__*/_react.default.createElement(_col.default, null, ' ', /*#__PURE__*/_react.default.createElement("a", {
      href: 'mailto:' + this.props.club.treasurerEmail
    }, " ", this.props.club.treasurerEmail))), /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref11, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement("span", null, this.props.club.treasurerName)))), /*#__PURE__*/_react.default.createElement(_setupClubAccountForm.default, {
      isOpened: this.state.addInitiatorOpen,
      onSubmit: this._onSubmit,
      onCancel: this._onToggleAddInitiator
    })));
  }
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
var _ref12 = {
  id: true,
  clubName: true,
  initiatorEmail: true,
  initiatorName: true,
  treasurerEmail: true,
  treasurerName: true,
  hasBankDetailsHash: true,
  hasStripeSetup: true,
  treasurerEmailSent: true,
  verificationStatus: true
};
var _default = exports.default = (0, _reactBicycle.connect)(Club, props => ({
  ["club(id:" + JSON.stringify(+props.match.params.clubID) + ")"]: _ref12
}), (client, props) => ({
  onUpdate(data) {
    return client.update('Club.set', data);
  },
  onSetupAccount(data) {
    return client.update('Club.setupAccount', data);
  },
  onSendInstructionsToTreasurer(clubID) {
    return client.update('Club.sendInstructionsToTreasurer', {
      clubID
    });
  }
}));